import { useNavigate } from 'react-router-dom'
import Text from '../elements/Typo/Text'
import { useNotificationApi } from '../store/api/hooks/notificationApiHook'
import toast from 'react-hot-toast'
import moment from 'moment'
import { trackEvent } from '../_common/functions'

interface Props {
    data: any
}

const NotificationElement: React.FC<Props> = ({ data }) => {
    const navigate = useNavigate()
    const notificationApi: any = useNotificationApi()
    const APP_URL = process.env.REACT_APP_APP_URL

    const actionHandeler = () => {
        trackEvent('notification_item_clicked', { notification_id: data.id, has_redirect_url: !!data.redirect_url })
        const payload: any = {
            notification_ids: data.id,
        }
        notificationApi.notificationmarkallread(
            payload,
            (resp: any) => {
                trackEvent('notification_mark_single_read_success', { notification_id: data.id })
                if (data.redirect_url) {
                    const redirect_url = data.redirect_url.replace(APP_URL, '')
                    trackEvent('notification_navigated', { notification_id: data.id, destination_path: redirect_url })
                    void navigate(redirect_url)
                }
            },
            (err: any) => {
                trackEvent('notification_mark_single_read_failed', { notification_id: data.id })
                toast.error(err.message)
            },
        )
    }

    return (
        <button type="button" data-testid="notification-root" onClick={actionHandeler} className="shadow-1 cursor-pointer rounded-[0.833rem] p-[1.042rem] flex flex-col gap-[0.833rem] bg-white border border-[#E5E5E5]">
            <Text size="18" className="font-semibold !leading-none">
                {data.title}
            </Text>
            <Text size="md" className="text-[#616161]">
                {data.description}
            </Text>
            <Text size="xs" className="text-[#616161] text-end">
                {moment.utc(data.created_at).local().format('MM-DD-YYYY HH:mm')}
            </Text>
        </button>
    )
}
export default NotificationElement
